export default {
  //Errors
  notFound: 'شرکت حمل و نقل یافت نشد',

  // Words
  activeCouriers: 'شرکت های حمل و نقل فعال',
  countryCode: 'کد کشوری',
  courierActived: 'شرکت حمل و نقل فعال شد',
  courierProfileStatus: 'وضعیت پروفایل شرکت حمل و نقل',
  courierRemoved: 'شرکت حمل و نقل حذف شد',
  courierSuspended: 'شرکت حمل و نقل تعلیق شد',
  courierUpdated: 'شرکت حمل و نقل به روز رسانی شد',
  newCourierAdded: 'شرکت حمل و نقل جدید افزوده شد',
  operatorName: 'نام متصدی',
  operatorCellNumber: 'شماره همراه متصدی',
  suspendedCouriers: 'شرکت های حمل و نقل تعلیق شده',
  clickHereForFillBasicInfo: 'جهت تکمیل اطلاعات پایه خود، اینجا کلیک کنید',
  fillingDataMessage: 'دریافت اطلاعات دقیق شما و دیگران ، ضامن سلامتی معاملات و آرامش خاطر شماست. از صبر و شکیبایی تان در تکمیل درست اطلاعات که صرفا یکبار نیاز است تشکر می نمائیم',
  confirmYourBasicData: 'لطفا اطلاعات پایه خود را تکمیل کنید',
  officialData: 'اطلاعات مکاتباتی',
  officialPhoneCode: 'پیش شماره تلفن ثابت',
  officialPhoneNumber: 'شماره تلفن ثابت',
  waitForAdminApproval: 'لطفا منتظر تأیید مدیر باشید',
  bankAccounts: {
    accountNumber: 'شماره حساب',
    accountOwnerName: 'نام صاحب حساب',
    accountTitle: 'عنوان حساب',
    bankAccounts: 'حساب های بانکی',
    bankAccountsUpdated: 'حساب های بانکی به روز رسانی شد',
    bankName: 'نام بانک',
    branchCode: 'کد شعبه',
    branchName: 'نام شعبه',
    enterBankName: 'نام بانک را وارد نمایید',
    shebaNumber: 'شماره شبا'
  },
  basicData: {
    address: 'آدرس',
    barterPayment: 'تهاتر',
    barterPaymentDescription: 'توضیحات تهاتر',
    basicData: 'اطلاعات پایه',
    basicDataUpdated: 'اطلاعات پایه به روز رسانی شد',
    birthdate: 'تاریخ تولد',
    cashPayment: 'نقد',
    cashPaymentDescription: 'توضیحات نقد',
    checkPayment: 'چک',
    checkPaymentDescription: 'توضیحات چک',
    city: 'شهر',
    economicalCode: 'کد اقتصادی',
    fatherName: 'نام پدر',
    identityData: 'اطلاعات هویتی',
    individual: 'حقیقی',
    legal: 'حقوقی',
    logo: 'لوگو',
    name: 'نام',
    nationalId: 'شناسه ملی',
    officialData: 'اطلاعات مکاتباتی',
    officialFaxNumber: 'شماره فکس',
    officialPhoneCode: 'پیش شماره تلفن ثابت',
    officialPhoneNumber: 'شماره تلفن ثابت',
    paymentPolicies: 'روش های تسویه',
    percent: 'درصد',
    province: 'استان',
    regDate: 'تاریخ ثبت',
    regNum: 'شماره ثبت',
    seal: 'تصویر مهر',
    zipCode: 'کد پستی'
  },
  contacts: {
    address: 'آدرس',
    birthdate: 'تاریخ تولد',
    contacts: 'اطلاعات تماس',
    contactsUpdated: 'اطلاعات تماس به روز رسانی شد',
    gender: 'جنسیت',
    notes: 'یادداشت ها',
    position: 'سمت',
    website: 'وب سایت'
  },
  signatories: {
    insertUnderContract: 'درج در زیر قرارداد',
    position: 'سمت',
    signatorCertification: 'گواهی امضا',
    signatories: 'صاحبان امضا',
    signatoriesUpdated: 'صاحبان امضا به روز رسانی شد',
    signatureImage: 'تصویر امضا'
  },
  statusDescription: {
    approved: 'اطلاعات {profile} شما تایید شده است و مجاز به فعالیت به عنوان {profile} هستید',
    disapproved: 'اطلاعات {profile} شما توسط تیم مدیریت رد شده است، با فشردن دکمه زیر، درخواست خود را ثبت نمایید. درخواست شما توسط تیم مدیریت بررسی و تایید خواهد شد',
    filling: 'اگر مایل به فعالیت به عنوان {profile} هستید، با فشردن دکمه زیر، درخواست خود را ثبت نمایید. درخواست شما توسط تیم مدیریت بررسی و تایید خواهد شد',
    pending: 'اطلاعات {profile} شما در انتظار تایید توسط تیم مدیریت میباشد'
  },
  statuses: {
    approved: 'تایید شده',
    disapproved: 'رد شده',
    filling: 'در حال تکمیل',
    pending: 'در انتظار تایید'
  }
}
